import { css, styled, linkClasses } from '@mui/material';

export const StyledVerticalContent = styled('div')(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    row-gap: ${theme.spacing('LARGE')};
  `
);

export const StyledVerticalInnerContent = styled('div')(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    row-gap: ${theme.spacing('SMALL')};
  `
);

export const StyledAlreadyUploadedDocumentContainer = styled(StyledVerticalInnerContent)(
  ({ theme }) => css`
    padding-bottom: ${theme.spacing('LARGE')};
    padding-top: ${theme.spacing('LARGE')};
    border-bottom: 1px solid ${theme.palette.gray.light_gray};

    &:first-of-type {
      padding-top: 0;
    }

    &:last-of-type {
      padding-bottom: 0;
      border-bottom: none;
    }
  `
);

export const StyledAlreadyUploadedDocument = styled('div')(
  ({ theme }) => css`
    display: flex;
    column-gap: ${theme.spacing('LARGE')};
  `
);

export const StyledAlreadyUploadedDocumentLinkContainer = styled('div')(
  ({ theme }) => css`
    display: flex;
    align-items: flex-end;
    column-gap: ${theme.spacing('XSMALL')};

    .${linkClasses.button} {
      align-items: center;
      display: flex;
      column-gap: ${theme.spacing('XSMALL')};
    }
  `
);
